import { gql } from '@apollo/client';

export default gql`
  mutation addAffiliateSeller($input: AddAffiliateInput!) {
    payload: addAffiliate(input: $input) {
      ... on AddAffiliateSuccess {
        successful
        affiliate {
          id
          name
          photo
          metadata {
            id
            name
            photo
            __typename
          }
          __typename
        }
        __typename
      }

      ... on AddAffiliateFailure {
        successful
      }
    }
  }
`;
